// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__25Cq-","checkbox--active":"Checkbox_checkbox--active__1-nXw"};